import { OnlinePage } from 'pageModules/OnlinePage';

export default OnlinePage;
